var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"loading",attrs:{"id":"loading"}},[_c('div',{staticClass:"loading-wrapper"},[_c('div',{staticClass:"loading-anim"}),_c('div',{staticClass:"loading-text"},[_vm._v("致力于让 Markdown 编辑和图片生成更简单")])])])
}]

export { render, staticRenderFns }